module.exports = __webpack_public_path__ + "img/subtitles-24px.2b2e2ecb.svg";